import { useCallback } from 'react';
import { useUserChoices } from '@/hooks/useUserChoices';
import { VIEWING_TAG_DEFAULT_KEY } from '@/constants/tagSelector';
import {
  parseViewingTagSelection,
  serializeViewingTagSelection,
  type ViewingTagSelection,
} from '@/utils/viewingTagSelection';

export interface UseDefaultViewingTagReturn {
  getDefaultViewingTag: () => ViewingTagSelection;
  saveDefaultViewingTag: (selection: ViewingTagSelection) => void;
  isReady: boolean;
}

export function useDefaultViewingTag(): UseDefaultViewingTagReturn {
  const { getValue, setValue, isSettingsReady } = useUserChoices();

  const getDefaultViewingTag = useCallback((): ViewingTagSelection => {
    return parseViewingTagSelection(getValue(VIEWING_TAG_DEFAULT_KEY));
  }, [getValue]);

  const saveDefaultViewingTag = useCallback(
    (selection: ViewingTagSelection): void => {
      setValue(
        VIEWING_TAG_DEFAULT_KEY,
        serializeViewingTagSelection(selection),
      );
    },
    [setValue],
  );

  return {
    getDefaultViewingTag,
    saveDefaultViewingTag,
    isReady: isSettingsReady,
  };
}
